<div class="row">
    <div class="col-1">
        <div class="row alignFlexCenter">
            <div class="OvalStyle ">
              
                    <img src="{{locationDetails.sourceImageUrl}}"
                    class="icons-and-illustrationsuser-interfacelocation">
            </div>
        </div>

        <div class="row alignFlexCenter">
            <div class="line3" ></div>
        </div>
        <div class="row alignFlexCenter">
            <div class="OvalStyle">
               
                    <img src="{{locationDetails.destinationImageUrl}}"
                    class="icons-and-illustrationsuser-interfacelocation">
            </div>
        </div>


    </div>
    <div class="col-8">
        <div class="margintop_12">
            <div class="secondarySubTextColor font_15">{{locationData[locationDetails.sourceInfo.sourceId] ?? locationData[locationDetails.sourceInfo.originId]}}</div>
            <div class="primarySubTextColor font_18"> {{locationData[locationDetails.sourceInfo.source] ?? locationData[locationDetails.sourceInfo.origin]}}</div>
            <div class="primarySubTextColor font_14">
                <span *ngIf="locationData[locationDetails.sourceInfo.addressLine]"> {{locationData[locationDetails.sourceInfo.addressLine]}},</span>
                <span *ngIf="locationData[locationDetails.sourceInfo.city]">{{locationData[locationDetails.sourceInfo.city]}},</span>
                <span *ngIf="locationData[locationDetails.sourceInfo.postalCode]"> {{locationData[locationDetails.sourceInfo.postalCode]}},</span>
                <span *ngIf="locationData[locationDetails.sourceInfo.countryCode]"> {{locationData[locationDetails.sourceInfo.countryCode]}}</span>
            </div>
        </div>
        <div class="margintop_30">
            <div class="secondarySubTextColor font_15">{{locationData[locationDetails.destinationInfo.destinationId]}}</div>
            <div class="primarySubTextColor font_18"> {{locationData[locationDetails.destinationInfo.destination]}}</div>
            <div class="primarySubTextColor font_14">
                <span *ngIf="locationData[locationDetails.destinationInfo.addressLine]">{{locationData[locationDetails.destinationInfo.addressLine]}},</span>
                <span *ngIf="locationData[locationDetails.destinationInfo.city]"> {{locationData[locationDetails.destinationInfo.city]}},</span>
                <span *ngIf="locationData[locationDetails.destinationInfo.postalCode]">{{locationData[locationDetails.destinationInfo.postalCode]}},</span>
                <span *ngIf="locationData[locationDetails.destinationInfo.countryCode]">{{locationData[locationDetails.destinationInfo.countryCode]}}</span>
            </div>
        </div>
    </div>
    <div class="col-3 primarySubTextRight">
        <div class="margintop_12">
            <div class="secondarySubTextColor font_12">{{locationDetails.pickupLabel | translate}}</div>
            <div class="primarySubTextColor"> {{locationData[locationDetails.pickupdate]}} </div>
        </div>
        <div class="margintop_70">
            <div class="secondarySubTextColor font_12">{{locationDetails.departureLabel | translate}}</div>
            <div class="primarySubTextColor"> {{locationData[locationDetails.deliverydate]}}</div>
        </div>
    </div>
    <div class="overviewSeperator"></div>
</div>